export default{
    PleaseEnterSupplierName: "请输入商家名称",
    pleaseSelectMainBusinessCategory: "请选择经营类目",
    pleaseEnterContactName: "请输入联系人名称",
    pleaseEnterContactPhoneNumber: "请输入联系电话",
    pleaseEnterDetailedAddress: "请输入详细地址",
    pleaseSetYourPassword: "请设置密码",
    pleaseConfirmPassword: "请确认密码",
    NeedProvideBusinessLicense: "(请提供营业执照)",
    pleaseEnterTheNameOfLegalPerson: "请输入法人姓名",
    pleaseEnterThePhoneNumber: "请输入手机号码",
    pleaseEnterLegalPersonsIDCard: "请输入法人身份证",
    pleaseEnterUnifiedSocialCreditCode: "请输入统一社会信用码",
    pleaseSelectDate: "请选择日期",
    MustContainCombinationUppercaseNLowercaseLettersNNumbers: "必须包含大小写字母和数字的组合，不能使用特殊字符，长度在 6-20 之间",
    pleaseEnterTheAdminsPhoneNumber: "请输入管理员电话",
    threeToThirtyCharactersInLength: "限制长度 3 至 30 个字符",
    pleaseEnterTheNameOfTheAdmin: "请输入管理员名称",
    pleaseEnterThePassword: "请输入密码",
    pleaseEnterAccAndPsw: "请输入账号和密码",
    pleaseEnterPasswordAgain: "请再次输入密码",
    theTwoPasswordsRInconsistent: "两次输入密码不一致!",
    pleaseEnterTheWarehouseAddress: "请输入仓库地址",
    pleaseEnterTheLegalPersonPhoneNumber: "请输入法人电话",
    pleaseEnterTheLegalPersonIDNumber: "请输入法人身份证号",
    pleaseUploadBusinessLicense: "请上传营业执照",
    pleaseUploadID: "请上传身份证",
    pleaseFillInTheBusinessPeriod: "请填写营业期限",
    pleaseFillTheUnifiedScialCreditCode: "请填写统一社会信用码",

}